export const categories = [
  {
    id: 'free-movies',
    name: '免费影视',
    slug: 'free-movies',
    description: '海量免费影视资源在线观看，涵盖电影、电视剧、综艺、动漫等，无需注册即可畅享高清观影体验。',
    icon: 'ri-movie-2-line',
    color: 'accent',
    articleCount: 6,
  },
  {
    id: 'free-music',
    name: '免费音乐',
    slug: 'free-music',
    description: '免费在线音乐播放平台推荐，畅听千万正版歌曲，高品质音乐随心享受，支持在线试听与下载。',
    icon: 'ri-music-2-line',
    color: 'primary',
    articleCount: 5,
  },
  {
    id: 'free-tools',
    name: '免费工具',
    slug: 'free-tools',
    description: '精选实用免费在线工具合集，图片处理、文档转换、开发辅助等，提升工作与学习效率的必备利器。',
    icon: 'ri-tools-line',
    color: 'secondary',
    articleCount: 6,
  },
  {
    id: 'free-learning',
    name: '免费学习',
    slug: 'free-learning',
    description: '优质免费在线学习资源汇总，编程、设计、语言、职场技能全覆盖，助你零成本实现自我提升。',
    icon: 'ri-book-open-line',
    color: 'accent',
    articleCount: 5,
  },
  {
    id: 'free-reading',
    name: '免费阅读',
    slug: 'free-reading',
    description: '免费电子书与在线阅读平台推荐，小说、杂志、学术文献一应俱全，随时随地享受阅读乐趣。',
    icon: 'ri-book-read-line',
    color: 'primary',
    articleCount: 4,
  },
  {
    id: 'free-games',
    name: '免费游戏',
    slug: 'free-games',
    description: '免费在线游戏平台合集，无需下载安装，即点即玩，休闲、竞技、策略等多种类型任你选择。',
    icon: 'ri-gamepad-line',
    color: 'secondary',
    articleCount: 5,
  },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});